import React, { Component } from "react"
import "./HelpPack.scss"
import ScrollableAnchor from "react-scrollable-anchor";
import GreenList from "../GreenList/GreenList";
import _PackData from "../../api/HelpPack.json"
import PackItem from "./PackItem";
import { mobile } from "../Services/Agent"
import PackSelected from "./PackSelected";
import Swipeable from 'react-swipeable'

class HelpPack extends Component {
    constructor() {
        super();
        this.packClick = this.packClick.bind(this);
        this.countryWidth = this.countryWidth.bind(this);
        this.swipingRight = this.swipingRight.bind(this);
        this.swipingLeft = this.swipingLeft.bind(this);
        this.state = {
            current: 0,
            slider: {
                width: 1000
            }
        }
    }
    componentDidMount() {
        this.countryWidth();
        window.addEventListener("resize", this.countryWidth);
    }
    packClick(index) {
        var _index;
        const _length = _PackData.length - 1;
        const eleWidth = this.countryNode.firstChild.clientWidth;
        const half = Math.floor(_length / 2);
        index = (index <= 0 ? 0 : index);
        index = (index >= _PackData.length ? _length : index);
        _index = () => {
            if (mobile() && window.document.body.clientWidth < 1000) {
                return index >= 5 ? 5 : index;
            } else {
                return (index > half ? half : (index <= half ? index - 1 : index));
            }
        }
        this.setState({
            current: index,
            slider: {
                width: this.state.slider.width,
                transform: `translateX(${(_index() <= 0 ? 0 : _index() >= _length + 1 ? _length : _index()) * eleWidth}px)`
            }
        })
    }
    getCountries() {
        return _PackData.map((item, index) => <PackItem
            key={index} index={index} ID={index + 1} item={item}
            current={this.state.current} packClick={this.packClick}
        />)
    }
    summerCountries(node) {
        if (!node || node.childElementCount == 0) return;
        var Sum = 0;
        var Widths = [];
        for (var i = 0; i < node.childElementCount; i++) {
            if (!Widths[i]) {
                Widths.push(i),
                    Sum += Math.floor(node.children[i].clientWidth + parseInt(window.getComputedStyle(node.children[i]).marginLeft.replace("px", "")))
            }
        }
        Sum += 100;
        return Sum;
    }
    countryWidth() {
        if (this.countryNode && this.countryNode.children[0]) {
            const eleLength = this.countryNode.childElementCount;
            const eleWidth = this.summerCountries(this.countryNode);
            this.setState({
                slider: {
                    width: eleWidth
                }
            });
            window.setTimeout(() => {
                const eleWidth = this.summerCountries(this.countryNode);
                this.setState({
                    slider: {
                        width: eleWidth
                    }
                });
            }, 250);
        }
    }
    swipingLeft(e, absX) {
        if (this.state.isBusy) return;
        this.packClick(this.state.current + 1)
        this.setState({
            isBusy: true
        })
        window.setTimeout(() =>
            this.setState({
                isBusy: false
            }), 100)
    }
    swipingRight(e, absX) {
        if (this.state.isBusy) return;
        this.packClick(this.state.current - 1)
        this.setState({
            isBusy: true
        })
        window.setTimeout(() =>
            this.setState({
                isBusy: false
            }), 100)
    }
    render() {
        return (
            <ScrollableAnchor id="helppack">
                <section className="section section-helppack">
                    <div className="padding">
                        <div className="container">
                            <div className="headline">
                                <div className="head">חבילת הסיוע</div>
                                <div className="separator"></div>
                                <div className="desc">תגיד לנו איזו נבחרת אתה הולך לעודד במונדיאל הזה, ונגיד לך מה להזמין מ-BringBring סופרמרקט אונליין כדי שיהיה לך כושר ל-90 דקות</div>
                            </div>
                            <div className="slider-countries">
                                <Swipeable
                                    onSwipedRight={this.swipingRight}
                                    onSwipingLeft={this.swipingLeft} >
                                    <div className="slider-outer">
                                        <div className="overflow" style={Object.assign({}, this.state.slider, this.state.transform)} ref={countryNode => this.countryNode = countryNode}>
                                            {this.getCountries()}
                                        </div>
                                    </div>
                                </Swipeable>
                                <div className="controller">
                                    <div onClick={() => this.packClick(this.state.current - 1)} className={`arrow right ${this.state.current == 0 ? "disabled" : ""}`}></div>
                                    <div onClick={() => this.packClick(this.state.current + 1)} className={`arrow left ${this.state.current + 1 >= _PackData.length ? "disabled" : ""}`}></div>
                                </div>
                            </div>
                            <PackSelected ID={this.state.current + 1} current={this.state.current} />
                        </div>
                    </div>
                    <GreenList index={0} max={2} className="top" />
                </section>
            </ScrollableAnchor>
        )
    }
}

export default HelpPack;


// WEBPACK FOOTER //
// ./src/Components/HelpPack/HelpPack.jsx